module.exports = __webpack_public_path__ + "extrapolationAsset.d540745af0144d452a57c772ae247a10.png";